import moment from 'moment';
import Decimal from 'decimal.js';

export function required(value) {
  return value || value === false ? undefined : 'Required';
}
export function requiredTrue(value) {
  return value || value === true ? undefined : 'Required';
}

export function mandatoryList(value) {
  if (value != null) {
    if (value === '' || value.length === 0) {
      return 'Required';
    }
  }
  return value || value === false ? undefined : 'Required';
}

export function isValidDate(value) {
  return !value ||
    moment(value, ['DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ'], true).isValid()
    ? undefined
    : 'Invalid Date';
}

export function isValidDateAndTime(value) {
  return !value ||
    moment(value, ['DD/MM/YYYY HH:mm', 'YYYY-MM-DDTHH:mm:ssZ'], true).isValid()
    ? undefined
    : 'Invalid Date & Time';
}

export function number(value) {
  return !value || /^\d*[.]*\d*$/.test(value)
    ? undefined
    : 'Please enter a valid number';
}

export function dropDownNumber(value) {
  return value == undefined?'Please select from drop down':undefined  
}

export function integer(value) {
  return !value || /^\d*$/.test(value)
    ? undefined
    : 'Please enter a valid whole number';
}

export function percentage(value) {
  if (!value) {
    return undefined;
  }

  return /^\d*[.]*\d*$/.test(value) &&
    parseFloat(value) >= 1 &&
    parseFloat(value) <= 100
    ? undefined
    : 'Please enter a valid pecentage';
}

/**
 * Validates an email address and returns a warning message if it fails validation.
 * @param {String} value - value of the input
 * @returns {String | undefined}
 */
export function email(value) {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const message = 'Please enter a valid email';
  if (!value || typeof value !== 'string') return message;
  return regex.test(value.trim()) ? undefined : message;
}

export function isFourDigitCode(value) {
  const isFourDigitCode = /^[0-9]{4}$/.test(value);
  return isFourDigitCode ? undefined : 'Code must be 4 digits';
}

export function isFumigatingTechnicianRequired(technicianId, { startDate }) {
  if (startDate && !technicianId) {
    return 'Required';
  }
  return undefined;
}

export function isFumigatingHCNTechnicianRequired(technicianId, { endDate }) {
  if (endDate && !technicianId) {
    return 'Required';
  }
  return undefined;
}


export function isVentingTechnicianRequired(technicianId, { endDate }) {
  if (endDate && !technicianId) {
    return 'Required';
  }
  return undefined;
}

export function checkMB(value){
console.log('checkMB',value)
   if (value === null || value === undefined || value.toString().trim() === '') {
    return 0;
  }
    const parsedNum = Number(value);

  if(parsedNum<0 || parsedNum >300){
    console.log('There is an error',value)
    return 'Please review is greater than 300kgs'
  }
  return undefined
}

export function isGreaterThan(value,TestValue){
 console.log(value,TestValue)

   if (value === null || value === undefined || value.toString().trim() === '') {
    value =  0;
  }
   

  if(TestValue === undefined){TestValue = 0}
    const parsedNum = Number(value);

  if(parsedNum<0 || parsedNum >TestValue){
    return 'Please review number is greater than '+TestValue
  }
  return undefined
}

export const isGreaterThanDefault = (value, allValues) => {

  const testValue = Number(allValues.jas || 0);
  const parsedValue = Number(value || 0);

  if (parsedValue < 0 || parsedValue > testValue) {
    return 'Please review amount is greater than M3';
  }

  return undefined;
};

export const isGreaterThanDefaultCoverVol = (value, allValues) => {

  console.log(value,allValues)
  const testValue = Number(allValues.coveredVolume || 0);
  const parsedValue = Number(value || 0);

  if (parsedValue < 0 || parsedValue > testValue) {
    return 'Please review your amount';
  }

  return undefined;
};

export const donothing = (value, allValues) => {

 

  return undefined;
};

export function evenDecimal(value) {
  if (!value) return undefined;
  const x = new Decimal(value);
  const match = `${x.toNumber()}`.match(/^\d+(?:\.(\d))?$/);
  if (match) {
    if (!match[1] || +match[1] % 2 === 0) {
      return undefined;
    }
  }
  return 'Must be even decimal point';
}



export function checkEndTime(value,allValues){
 var {concentrationReadingItem} = allValues
 var endPhase = Array.isArray(concentrationReadingItem)
 ? concentrationReadingItem.filter(x => x.phase === 2)[0]
 : undefined;
 var endDateTimeString ;
 if(endPhase!=undefined){
    endDateTimeString = endPhase.readingDateTime
 }
 const ventDateTime = new Date(value);
 const endDate = new Date(endDateTimeString);
 return 'Required'
 /*
 if (isNaN(ventDateTime) || isNaN(endDate)) {
  console.log('checkEndTimeEndDate Invalid date encountered');
  return false;//'Invalid Date & Time';
}

 if (ventDateTime > endDate) {
  console.log('checkEndTime',ventDateTime > endDate)
return false;//'Invalid Date & Time'
} else if (ventDateTime < endDate) {
  console.log('checkEndTimeVentLessThanEnd',ventDateTime < endDate)
  return false;//'Invalid Date & Time';//'Vent date time must be greater than end date time'
} */
}

export function mandatory(value) {
  if (value === '') {
    return 'Required';
  }
}
